<div class="app-cards-resgatar" [class.pb-5]="data() && data().length == 0">
  @if (title()) {
  <h4 class="main-subtitle" [style.color]="labelColor">
    {{ title() }}
  </h4>
  }
  <div class="cards">
    @for (item of data(); track $index) {
      @if (!item.isCuponClube) {
        <div [class.click]="item.link?.length > 0" (click)="goTo(item.link)" class="bg-white card">
          @if (item.inactiveItem == true) {
            <div class="notClick"></div>
          }
          @if (item.image) {
            <div class="header" (click)="logdata()">
              <img class="icon" [src]="item.image" alt="User image">
              <h3 class="title">{{ item.title }}</h3>
            </div>
          }
          <div class="content">
            <p [innerHTML]="item.content"></p>
          </div>
          @if (item.value != '' || item.point != '' || item.cupom != '') {
            <div class="d-flex align-items-center justify-content-between mt-3">
              @if (item.cupom != '' && item.cupom != null) {
                <div class="coupon">
                  <p>
                    Cupom: <span>{{ item.cupom }}</span>
                  </p>
                </div>
              }
              <div class="points">
                <!-- Quando houver apenas requiredPoints -->
                @if (item.point != '' && item.value == '' && typeContent() == 'EXPERIENCE') {
                  <div class="point color-primary"
                    [ngStyle]="{'text-decoration': item.inactiveItem == true ? 'line-through' : '' }">
                    {{ item.point }} pontos
                  </div>
                }

                <!-- Quando houver requiredPoints e value -->
                @if (item.point != '' && item.value != '' && typeContent() == 'EXPERIENCE') {
                  <div class="point color-primary"
                    [ngStyle]="{'text-decoration': item.inactiveItem == true ? 'line-through' : '' }">
                    {{ item.point }} pontos
                  </div>
                  <div class="buy">
                    <span>ou</span>
                    <p> {{ item.value | customCurrency }}</p>
                  </div>
                }

                <!-- Quando houver apenas value -->
                @if (item.point == '' && item.value != '' && typeContent() == 'EXPERIENCE') {
                  <div class="buy">
                    <p> {{ item.value | customCurrency }}</p>
                  </div>
                }
              </div>
            </div>
          }

          <div class="buttons">
            @if (item.point != '' && item.rescue) {
              <app-button class="app-button button"
                [ngStyle]="{'width': item.point != '' ? item.value != '' ? '49%' : '100%' : '100%'}"
                [style]="'--bs-btn-padding-x: 1.4em; width: 100%;'" [buttonOptions]="checkInBtn"
                [disabled]="item.inactiveButton" (buttonClick)="rescueExperience(item)">
              </app-button>
            }
          </div>
        </div>
      }
      @if (item.isCuponClube) {
        <div class="bg-white card new-coupon">
          @if (item.inactiveItem == true) {
            <div class="notClick"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.8); z-index: 1;">
            </div>
          }
          <div class="header">
            <h3 class="title" style="font-size: 18px; font-weight: bold; margin: 0;">{{ item.title }}</h3>
          </div>
          <div class="content">
            <p style="margin: 8px 0;">
              <strong>Valor:</strong> {{ item.value }}
            </p>
            <p style="margin: 8px 0;">
              <strong>{{ item.valid }}</strong>
            </p>

            <p style="margin: 8px 0;">
              <strong>Disponível para:</strong> {{ item.usageTypes }}
            </p>
          </div>
          <div class="buttons" style="margin-top: 16px;">
            @if (item.point != '' && item.rescue) {
              <app-button class="app-button button"
                [ngStyle]="{'width': item.point != '' ? item.value != '' ? '49%' : '100%' : '100%'}"
                [style]="'--bs-btn-padding-x: 1.4em; width: 100%;'" [buttonOptions]="checkInBtn"
                [disabled]="item.inactiveButton" (buttonClick)="rescueExperience(item)">
              </app-button>
            }
          </div>
        </div>
      }
    }
    @if (data() && data().length == 0) {
      <div class="no-data-message">
        <p>Sem experiências resgatadas</p>
      </div>
    }
  </div>
</div>

<app-payment-options-modal [paymentModalData]="selectedItem" [options]="modalOptions"
  (confirmActionChange)="onPaymentOptionSelected($event)">
</app-payment-options-modal>